import gql from "graphql-tag";

export const UPDATE_USER = gql`
  mutation updateUser(
    $firstName: String
    $lastName: String
    $photoUrl: String
    $id: uuid = ""
  ) {
    update_User(
      _set: { lastName: $lastName, firstName: $firstName, photoUrl: $photoUrl }
      where: { id: { _eq: $id } }
    ) {
      affected_rows
    }
  }
`;
export const RESEND_VERIFY_EMAIL = gql`
  mutation {
    resendVerifyEmail {
      affected_rows
    }
  }
`;

export const GENERATE_ACCONT_PAYMENT_DETAILS = gql`
  mutation {
    generateStripeAccountDetails {
      chargesEnabled
      detailsSubmitted
      payoutsEnabled
    }
  }
`;
export const GENERATE_ACCONT_PAYMENT_URL = gql`
  mutation {
    generateStripeAccountDetails {
      accountUrl
      chargesEnabled
      detailsSubmitted
      payoutsEnabled
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation changePassword($newPassword: String, $oldPassword: String) {
    changePassword(newPassword: $newPassword, oldPassword: $oldPassword) {
      affected_rows
    }
  }
`;

export const LOGOUT = gql`
  mutation logout {
    logout {
      affected_rows
    }
  }
`;

export const REQUEST_QRCODE = gql`
  mutation requestQrCodes($menuId: uuid!, $tablesNumber: Int) {
    requestQrCodes(menuId: $menuId, tablesNumber: $tablesNumber) {
      affected_rows
    }
  }
`;

export const UPDATE_MENU = gql`
  mutation updateMenu(
    $menuId: uuid
    $pdfUrl: String
    $name: String
    $bannerUrl: String
    $menuType: String
  ) {
    update_Menu(
      where: { id: { _eq: $menuId } }
      _set: {
        bannerUrl: $bannerUrl
        name: $name
        pdfUrl: $pdfUrl
        menuType: $menuType
      }
    ) {
      affected_rows
    }
  }
`;

export const UPDATE_MENU_TYPE = gql`
  mutation updateMenuType($menuId: uuid!, $pdfUrl: String, $menuType: String) {
    update_Menu(
      where: { id: { _eq: $menuId } }
      _set: { pdfUrl: $pdfUrl, menuType: $menuType }
    ) {
      affected_rows
    }
  }
`;

export const GENERATE_S3_URL = gql`
  mutation generateS3UploadUrl($fileName: String!) {
    generateS3UploadUrl(fileName: $fileName) {
      uploadUrl
    }
  }
`;

export const ADD_CATEGORY = gql`
  mutation addCategory($menuId: uuid!, $name: String!, $sortIndex: Int!) {
    insert_Category(
      objects: { menuId: $menuId, name: $name, sortIndex: $sortIndex }
    ) {
      affected_rows
      returning {
        id
        name
        sortIndex
        Dishes(where: {}) {
          id
          inStock
          name
        }
      }
    }
  }
`;

export const UPDATE_CATEGORY_SORT_INDEX = gql`
  mutation MyMutation($objects: [Category_insert_input!]!) {
    insert_Category(
      objects: $objects
      on_conflict: {
        constraint: Category_menuId_name_key
        update_columns: [name, sortIndex]
      }
    ) {
      affected_rows
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation updateCategory($menuId: uuid!, $id: uuid!, $name: String!) {
    update_Category(
      where: { Menu: { id: { _eq: $menuId } }, id: { _eq: $id } }
      _set: { name: $name }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_CATEGORY = gql`
  mutation deleteCategory($menuId: uuid!, $id: uuid!) {
    delete_Category(
      where: { Menu: { id: { _eq: $menuId } }, id: { _eq: $id } }
    ) {
      affected_rows
    }
  }
`;

export const ADD_DISH = gql`
  mutation addDish(
    $categoryId: uuid!
    $name: String!
    $price: numeric!
    $sortIndex: Int
    $availableTo: time
    $availableFrom: time
    $description: String
    $inStock: Boolean
    $photoUrl: String
  ) {
    insert_Dish(
      objects: {
        categoryId: $categoryId
        name: $name
        sortIndex: $sortIndex
        price: $price
        availableTo: $availableTo
        availableFrom: $availableFrom
        description: $description
        inStock: $inStock
        photoUrl: $photoUrl
      }
    ) {
      affected_rows
      returning {
        id
        name
        sortIndex
        inStock
        price
      }
    }
  }
`;

export const UPDATE_DISH = gql`
  mutation updateDish(
    $id: uuid!
    # $categoryId: uuid
    $availableFrom: time
    $availableTo: time
    $categoryId1: uuid
    $description: String
    $inStock: Boolean
    $name: String
    $photoUrl: String
    $price: numeric
    $sortIndex: Int
  ) {
    update_Dish(
      where: {
        id: { _eq: $id }
        #  Category: { id: { _eq: $categoryId } }
      }
      _set: {
        availableFrom: $availableFrom
        availableTo: $availableTo
        description: $description
        inStock: $inStock
        name: $name
        photoUrl: $photoUrl
        price: $price
        sortIndex: $sortIndex
      }
    ) {
      affected_rows
    }
  }
`;
export const UPDATE_DISH_NAME = gql`
  mutation updateDishName($name: String, $id: uuid) {
    update_Dish(where: { id: { _eq: $id } }, _set: { name: $name }) {
      affected_rows
    }
  }
`;
export const UPDATE_DISH_SORT_INDEX = gql`
  mutation updateDishSortIdex($objects: [Dish_insert_input!]!) {
    insert_Dish(
      objects: $objects
      on_conflict: {
        constraint: Dish_name_categoryId_key
        update_columns: [sortIndex]
      }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_DISH = gql`
  mutation deleteDish($id: uuid!) {
    delete_Dish_by_pk(id: $id) {
      id
    }
  }
`;

export const ADD_MODIFIER = gql`
  mutation addModifier(
    $itemMax: Int
    $menuId: uuid
    $name: String
    $totalMax: Int
    $totalMin: Int
    $items: [ModifierItem_insert_input!]!
  ) {
    insert_Modifier(
      objects: {
        itemMax: $itemMax
        menuId: $menuId
        name: $name
        totalMax: $totalMax
        totalMin: $totalMin
        ModifierItems: { data: $items }
      }
    ) {
      returning {
        id
        ModifierItems {
          id
          name
          price
          sortIndex
        }
      }
    }
  }
`;

export const UPDATE_MODIFIER = gql`
  mutation updateModifier(
    $items: [String!]
    $objects: [ModifierItem_insert_input!]!
    $modifierId: uuid
    $itemMax: Int
    $name: String
    $totalMax: Int
    $totalMin: Int
  ) {
    a: delete_ModifierItem(
      where: { name: { _nin: $items }, modifierId: { _eq: $modifierId } }
    ) {
      affected_rows
    }
    b: insert_ModifierItem(
      on_conflict: {
        constraint: ModifierItem_name_modifierId_key
        update_columns: [name, price, sortIndex]
      }
      objects: $objects
    ) {
      returning {
        id
      }
    }
    c: update_Modifier(
      _set: {
        itemMax: $itemMax
        name: $name
        totalMax: $totalMax
        totalMin: $totalMin
      }
      where: { id: { _eq: $modifierId } }
    ) {
      returning {
        id
        itemMax
        menuId
        name
        totalMax
        totalMin
        ModifierItems(order_by: { sortIndex: asc }) {
          id
          modifierId
          name
          price
          sortIndex
        }
      }
    }
  }
`;

export const DELETE_MODIFIER = gql`
  mutation MyMutation($id: uuid!) {
    delete_Modifier(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`;
export const ADD_DISH_MODIFIER = gql`
  mutation addDishModifier($dishId: uuid, $modifierId: uuid, $sortIndex: Int) {
    insert_DishModifier(
      objects: {
        modifierId: $modifierId
        dishId: $dishId
        sortIndex: $sortIndex
      }
    ) {
      affected_rows
      returning {
        id
      }
    }
  }
`;
export const UPDATE_DISH_MODIFIER_SORT_INDEX = gql`
  mutation MyMutation($objects: [DishModifier_insert_input!]!) {
    insert_DishModifier(
      objects: $objects
      on_conflict: {
        constraint: DishModifier_dishId_modifierId_key
        update_columns: [sortIndex]
      }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_DISH_MODIFIER = gql`
  mutation MyMutation($id: uuid!, $dishId: uuid!) {
    delete_DishModifier(
      where: { Modifier: { id: { _eq: $id } }, Dish: { id: { _eq: $dishId } } }
    ) {
      affected_rows
      returning {
        id
      }
    }
  }
`;
